import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-960db818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = {
  id: "merchants_action_toolbar",
  class: "container-fluid d-flex flex-md-row flex-md-stack container-xxl"
}
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-700 fw-bolder pe-3 px-4" }, "Merchant Actions:", -1))
const _hoisted_6 = { class: "d-flex flex-shrink-0" }
const _hoisted_7 = {
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "",
  "data-bs-original-title": "Merchant Actions"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<button class=\"btn btn-sm btn-icon btn-active-color-primary\" data-kt-menu-trigger=\"click\" data-kt-menu-placement=\"bottom-start\" data-kt-menu-flip=\"bottom-end\" data-v-960db818><span class=\"svg-icon svg-icon-2x\" data-v-960db818><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-960db818><rect opacity=\"0.3\" x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"4\" fill=\"black\" data-v-960db818></rect><rect x=\"11\" y=\"11\" width=\"2.6\" height=\"2.6\" rx=\"1.3\" fill=\"black\" data-v-960db818></rect><rect x=\"15\" y=\"11\" width=\"2.6\" height=\"2.6\" rx=\"1.3\" fill=\"black\" data-v-960db818></rect><rect x=\"7\" y=\"11\" width=\"2.6\" height=\"2.6\" rx=\"1.3\" fill=\"black\" data-v-960db818></rect></svg></span></button>", 1)
const _hoisted_9 = { class: "d-flex align-items-center flex-shrink-0 pe-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bullet bg-secondary h-35px w-1px mx-5" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-gray-700 fw-bolder pe-5 ps-1 onboarding-progress" }, "Onboarding Progress:", -1))
const _hoisted_12 = { class: "progress w-100px w-xl-150px w-xxl-300px h-25px bg-light-success" }
const _hoisted_13 = ["aria-valuenow"]
const _hoisted_14 = {
  key: 0,
  class: "toolbar custom-progress-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantActions = _resolveComponent("MerchantActions")!
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_MerchantActions, { onTriggerAction: _ctx.onAction }, null, 8, ["onTriggerAction"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "progress-bar rounded bg-success fs-7 fw-bolder",
              role: "progressbar",
              style: _normalizeStyle(`width: ${_ctx.onboardProgress}%`),
              "aria-valuenow": _ctx.onboardProgress,
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, _toDisplayString(_ctx.onboardProgress) + "% ", 13, _hoisted_13)
          ])
        ])
      ])
    ]),
    (_ctx.showProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_el_progress, {
            percentage: 50,
            indeterminate: true,
            "show-text": false
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}